<template>
    <div class="year_nav">
        <button type="button" v-if="navigationData.next" @click="goToNext" class="arr next"></button>
        <button type="button" v-if="navigationData.prev" @click="goToPrev" class="arr prev"></button>
        {{ navigationData.year }}
        <span v-if="navigationData.month">{{ navigationData.month }}</span>
    </div>
</template>

<script>
export default {
    name: 'YearNavigation',
    props: { navigationData:{ default:{} }, slideIdx:{ default:0 } },
    methods: {
        goToPrev(){ this.$root.$emit('goToPrev', { slideIdx:this.slideIdx }) },
        goToNext(){ this.$root.$emit('goToNext', { slideIdx:this.slideIdx }) }
    }
}
</script>

<style lang="scss">
    .year_nav {
        font-size:fsz(3rem); font-family:$gorod; position:relative; display:inline-block; padding:30px 0;
        span { position:absolute; right:68%; top:74%; font-size:1.3rem; color:transparent; -webkit-text-stroke:1px #fff; text-align:right; line-height:1.15 }

        .arr {
            position:absolute; left:50%; transform:translateX(-50%); width:0; height:0; border-style:solid; cursor:pointer;
            &:focus { outline:none }
            &.next { top:8%; border-width:0 25px 20px 25px; border-color:transparent transparent $yellow transparent; animation:year_arrow_top 4s ease 0s infinite }
            &.prev { bottom:8%; border-width:20px 25px 0 25px; border-color:$yellow transparent transparent transparent; animation:year_arrow_bottom 4s ease 0s infinite }
        }

        &:hover {
            .arr {
                animation-play-state:paused;
            }
        }

        @keyframes year_arrow_top {
            0%, 10%, 20%, 40%, 100% { top:8% }
            5% { top:4% }
        }

        @keyframes year_arrow_bottom {
            0%, 10%, 20%, 40%, 100% { bottom:8% }
            5% { bottom:4% }
        }

        @include small {
            font-size:1.5rem; width:100%; text-align:center;
        }
        @include medium {
            font-size:1.5rem;
        }
    }
</style>